'use client';

import React, { useState, useEffect, Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import ParticleCanvas from '../particle-showcase/components/ParticleCanvas';
import type { SimConfig, RuntimeStats, ParticleForm, ParticleFormation } from '../particle-showcase/components/ParticleShowcaseClient';

const DEFAULT_CONFIG: SimConfig = {
  form: 'fish',
  speed: 1.0,
  density: 120,
  colorPalette: 'ocean',
  bodyColor: '',
  customColors: ['#ef4444', '#22c55e', '#3b82f6'],
  particleSize: 1.0,
  formation: 'freeform',
  bgType: 'none',
  bgColor: '#060d18',
  bgImage: '',
};

function EmbedCanvas() {
  const searchParams = useSearchParams();
  const [config, setConfig] = useState<SimConfig>(DEFAULT_CONFIG);
  const [stats, setStats] = useState<RuntimeStats>({ fps: 60, particleCount: 0, isDestroying: false });

  useEffect(() => {
    const form = (searchParams.get('form') as ParticleForm) || DEFAULT_CONFIG.form;
    const speed = parseFloat(searchParams.get('speed') || String(DEFAULT_CONFIG.speed));
    const density = parseInt(searchParams.get('density') || String(DEFAULT_CONFIG.density), 10);
    const colorPalette = searchParams.get('palette') || DEFAULT_CONFIG.colorPalette;
    const bodyColorParam = searchParams.get('bodyColor');
    const bodyColor = bodyColorParam ? `#${bodyColorParam}` : DEFAULT_CONFIG.bodyColor;
    const customColorsParam = searchParams.get('customColors');
    const customColors = customColorsParam
      ? customColorsParam.split(',').map((c) => `#${c}`)
      : DEFAULT_CONFIG.customColors;
    const particleSize = parseFloat(searchParams.get('size') || String(DEFAULT_CONFIG.particleSize));
    const formation = (searchParams.get('formation') as ParticleFormation) || DEFAULT_CONFIG.formation;
    const bgType = (searchParams.get('bgType') as 'color' | 'image' | 'none') || 'none';
    const bgColor = searchParams.get('bgColor') ? `#${searchParams.get('bgColor')}` : DEFAULT_CONFIG.bgColor;
    const bgImage = searchParams.get('bgImage') || '';

    setConfig({
      form,
      speed: isNaN(speed) ? DEFAULT_CONFIG.speed : speed,
      density: isNaN(density) ? DEFAULT_CONFIG.density : density,
      colorPalette,
      bodyColor,
      customColors,
      particleSize: isNaN(particleSize) ? DEFAULT_CONFIG.particleSize : particleSize,
      formation,
      bgType,
      bgColor,
      bgImage,
    });
  }, [searchParams]);

  return (
    <>
      <style>{`html, body { background: transparent !important; }`}</style>
      <div className="w-screen h-screen overflow-hidden" style={{ background: 'transparent' }}>
        <ParticleCanvas config={config} onStatsUpdate={setStats} />
      </div>
    </>
  );
}

export default function ParticleEmbedPage() {
  return (
    <Suspense fallback={<div style={{ background: 'transparent', width: '100vw', height: '100vh' }} />}>
      <EmbedCanvas />
    </Suspense>
  );
}
